<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="amzSkuSpecCode"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      :cell-class-name="cellClassName"
      :checkbox-config="{ highlight: true, checkAll: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:specName="{ row }">
        <span>{{ row.specName }}</span>
        <br />
        <span>{{ row.specNameEn }}</span>
        <br />
        <span>{{ row.specNo }}</span>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
        <br />
        <span>SKU:</span><span style="color: #409EFF">{{ row.amzSkuNo }}</span>
        <br />
        <span>SPU:</span><span style="color: #409EFF">{{ row.amzSpuNo }}</span>
      </template>
      <template v-slot:sizeQuantity="{ row }">
        <span>{{ row.displaySpec }} x {{ row.specQty }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tableHeight: { type: Number, default: 300 },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
    }
  },
  mounted() {
    // 默认全选
    this.$nextTick(() => {
      this.$refs.table.setAllCheckboxRow(true)
    })
  },
  methods: {
    cellClassName({ column }) {
      return column.property === 'checkbox' ? '' : 'align-top'
    },
    checkboxChange({ records }) {
      this.$emit('checkbox-change', records)
    },
    getSelectedProducts() {
      return this.$refs.table.getCheckboxRecords()
    },
  },
}
</script>

